import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchComponent),
      multi: true,
    },
  ],
})
export class SwitchComponent implements OnInit, ControlValueAccessor {
  private _value: boolean;
  private _disabled = false;
  set value(v: boolean) {
    if (v != this._value) {
      this._value = v;
      this.onChanged(v);
    }
  }

  get value() {
    return this._value;
  }

  private onChanged = _ => {};
  private onTouched = () => {};
  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = value;
  }

  constructor() {}

  ngOnInit() {}

  isActive() {
    return this._value;
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: boolean): void {
    this.value = obj;
  }

  toggle() {
    if (!this.disabled) {
      this.writeValue(!this.value);
    }
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
}
